// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__3lrw-","lottie":"Loading_lottie__2-JhC","fact":"Loading_fact__2gO0M"};